import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CurrentUserService } from './current-user.service';

type Audience = 'admin' | 'portal' | 'onboarding';

@Injectable()
export class AudienceGuard implements CanActivate, CanActivateChild {

  constructor(
    private currentUserService: CurrentUserService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkAccess(route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkAccess(childRoute);
  }

  private checkAccess(route: ActivatedRouteSnapshot): Observable<boolean> {
    const audience: Audience | undefined = route.data['audience'];

    return this.currentUserService.ensureLoaded().pipe(
      map((user) => {
        if (user === null) {
          this.router.navigate(['/pages/error']);
          return false;
        }

        const isClientUser = this.currentUserService.isClientUser();
        const isOnboardingOnlyUser = this.currentUserService.isOnboardingOnlyUser();

        if (!audience) {
          if (isOnboardingOnlyUser) {
            this.router.navigate(['/portal/onboarding']);
            return false;
          }
          return true;
        }

        if (audience === 'onboarding' && !isOnboardingOnlyUser) {
          this.router.navigate([isClientUser ? '/portal/transactions' : '/dashboard']);
          return false;
        }

        if (audience === 'portal' && (!isClientUser || isOnboardingOnlyUser)) {
          this.router.navigate([isOnboardingOnlyUser ? '/portal/onboarding' : '/dashboard']);
          return false;
        }

        if (audience === 'admin' && (isClientUser || isOnboardingOnlyUser)) {
          this.router.navigate([isOnboardingOnlyUser ? '/portal/onboarding' : '/portal/transactions']);
          return false;
        }

        return true;
      })
    );
  }
}
